import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { translateAndSortAscendant } from "../../../../common/helper";
import { DropDownMultiCheck } from "../DropDownMultiCheck";
import IconDelete from "../../../../layout/others/icon-x.svg";
import Select from "../../../../components/Select";
import { Row } from "react-bootstrap";

export default function Language({
  searchObject,
  setSearchObject,
  onChange,
  t,
  errors,
  hideSelected
}) {
  const [languages, setLanguages] = useState([]);
  const [languageLevels, setLanguageLevels] = useState([]);

  useEffect(() => {
    CommonService.getAllLanguageLevels().then((data) => {
      data.push({ id: 0, description: t("N1 - Native") });
      setLanguageLevels(translateAndSortAscendant(data, "description"));
    });
    CommonService.getAllLanguages().then((data) =>
      setLanguages(translateAndSortAscendant(data, "description"))
    );
  }, []);

  function setSelectedLanguageLevel(list) {
    let newOrderedList = languageLevels.indexOf(list[0]);
    if (newOrderedList > -1) {
      list = languageLevels.slice(newOrderedList);
    }
    setSearchObject({ ...searchObject, languageLevels: list });
  }

  function clearLanguageLevel() {
    let _searchObject = { ...searchObject };
    _searchObject.languageLevels.length = 0;

    setSearchObject(_searchObject);
  }

  return (
    <div>
      <Row>
        <div className="col mt-2">
          <legend className="fontsize-legend">{t("Language")}</legend>{" "}
          {errors.languageId && (
            <span className="error-msg-language">{errors.languageId}</span>
          )}
          <Select
            className="form-select fontsize-legend"
            name="languageId"
            id="languageId"
            onChange={onChange}
            value={searchObject.languageId || ""}
          >
            <option value=""></option>
            {languages.map((language) => (
              <option
                className="fontsize-legend"
                key={language.id}
                value={language.id}
              >
                {t(language.description)}
              </option>
            ))}
          </Select>
        </div>
        <div className="col m-2">
          <legend className="fontsize-legend">{t("Level")}</legend>
          {searchObject.languageLevels?.length !== 0 && (
            <button
              onClick={clearLanguageLevel}
              className="btn-clear-language-level position-clear-button"
            >
              <img src={IconDelete} alt="ico-ppl" height="12px" width="auto" />
            </button>
          )}
          {errors.languageLevels && (
            <span className="error-msg-level">{errors.languageLevels}</span>
          )}
          <div className="language-level-mobile">
            <DropDownMultiCheck
              dataList={languageLevels}
              selecteds={searchObject.languageLevels || []}
              setSelecteds={setSelectedLanguageLevel}
              hideSelected={hideSelected}
            />
          </div>
        </div>
      </Row>
    </div>
  );
}
